export default __webpack_public_path__ + "72134d0005e49b1f91e9110b225b8cd3.png";